import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreatePayerRequest } from '../../models/payer/payer.model';

@Injectable({
  providedIn: 'root'
})
export abstract class PayerRepository {
  abstract AddNewPayers(newPayer: CreatePayerRequest): Observable<any>;
}
